<template>
  <div id="app" class="l-app">
    <Navbar v-if="isNavbar"></Navbar>
    <transition name="fade" mode="out-in" @before-leave="isLoading = true" @after-enter="isLoading = false">
      <router-view class="l-article" @page-navbar="receiveNavbar" @loading="receiveLoading" v-bind:position="position"></router-view>
      <router-view name="sessions" class="l-sessions" @page-navbar="receiveNavbar" @loading="receiveLoading"></router-view>
    </transition>
    <view-loading :loading="isLoading" />
  </div>
</template>

<script>
import ViewLoading from './components/ViewLoading';
import Navbar from "@/components/navbar/Navbar";
import {defineComponent, onMounted, provide, ref} from "vue";
import {useStickyScroll} from "@/composables/useStickyScroll";
import {useRouter} from "vue-router/composables";
import {useNavigateByWorkerStatus, useSignupStore, useStepStore} from "@/composables/signup";
import {SIGNUP_STORE} from "@/constants/InjectionKeys";
import {useUuidStore} from "@/composables/useUuidStore";

export default defineComponent({
  name: 'App',
  components: { ViewLoading, Navbar },
  setup() {
    const position = ref(0)

    const isNavbar = ref(true)
    const receiveNavbar = (value) => {
      isNavbar.value = value;
    }

    const isLoading = ref(false)
    const receiveLoading = (value) => {
      isLoading.value = value
    }

    // サインアップストア初期化
    const signupStore = useSignupStore()
    signupStore.restoreWorker()
    provide(SIGNUP_STORE, signupStore)

    // 今のステップストア初期化
    const stepStore = useStepStore()
    stepStore.watchStep()

    // UUID初期化
    useUuidStore().setUuidIfNotExists()

    // signup系のパスだったら、前回のページに飛ばす
    if (stepStore.shouldNavigate()) {
      stepStore.restoreRoute()
      useNavigateByWorkerStatus(isLoading).navigate()
    }

    onMounted(() => {
      useStickyScroll()
    })

    // ページ遷移したら読み込み表示消す
    const router = useRouter()
    router.afterEach((_to, _from) => {
      isLoading.value = false
    })

    return { position, isNavbar, isLoading, receiveNavbar, receiveLoading }
  }
})
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter-active {
  transition-delay: .1s;
}

.fade-enter, .fade-leave-active {
  opacity: 0;
}

.fade-enter {
  position: absolute;
}
</style>
